import { render, staticRenderFns } from "./ArchivesWorkPaddyShow.vue?vue&type=template&id=373e5e6f&"
import script from "./ArchivesWorkPaddyShow.vue?vue&type=script&lang=js&"
export * from "./ArchivesWorkPaddyShow.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesWorkPaddyShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports